import {
  dealGasOrder
} from '@/cllib/sys_lib'

import {
  dateOperating
} from '@/cllib/tools'

import {
  tableSortDatas
} from '@/fm-table/lib/sort_list'

import {
  dataListFilter
} from '@/fm-table/lib/tools'

import {
  gasOrderGetData,
  gasOrderPrediction,
  gasOrderGetPredictionStatus,
  gasOrderUpdateData,
  gasOrderUpdateIsSend,
  gasOrderClearData,
  gasOrderOutput,
  gasOrderConfirm
} from '@/api/api'

const state = {
  baseGasOrderList: [],
  gasOrderList: [],
  gasOrderSearchParm: {},
  gasOrderSortParm: {},
  predictionLoading: false
}

const getters = {
  gasOrderSearchParm: state => state.gasOrderSearchParm,
  gasOrderSortParm: state => state.gasOrderSortParm,
  baseGasOrderList: state => state.baseGasOrderList,
  gasOrderList: state => state.gasOrderList,
  predictionLoading: state => state.predictionLoading
}

const actions = {
  loadGasOrderList ({ dispatch }, parm) {
    return gasOrderGetData(parm).then((data) => {
      dispatch('setBaseGasOrderList', dealGasOrder(data))
      dispatch('dealGasOrderList')
    })
  },
  dealGasOrderList ({ dispatch, getters }) {
    let data = getters.baseGasOrderList
    data = dataListFilter(data, getters.gasOrderSearchParm.searchMap, getters.gasOrderSearchParm.searchConfig)
    data = tableSortDatas(data, getters.gasOrderSortParm.relationSort, getters.gasOrderSortParm.sortMap, getters.gasOrderSortParm.sortConfig)
    dispatch('setGasOrderList', data)
  },
  gasOrderConfirm ({ dispatch }, parm) {
    return gasOrderConfirm(parm)
  },
  gasOrderClearData ({ dispatch }, parm) {
    return gasOrderClearData(parm)
  },
  gasOrderOutput ({ dispatch }, parm) {
    return gasOrderOutput(parm)
  },
  gasOrderPrediction ({ dispatch }, parm) {
    return gasOrderPrediction(parm)
  },
  gasOrderEditOne ({ commit }, parm) {
    commit('gasOrderEditOne', parm)
    commit('gasOrderEditBaseOne', parm)
  },
  gasOrderUpdateIsSend ({ dispatch, getters }, parm) {
    return gasOrderUpdateIsSend(parm)
  },
  gasOrderUpdateData ({ dispatch }, parm) {
    return gasOrderUpdateData(parm)
  },
  getOrderPredictionStatus ({ dispatch, getters }) {
    setTimeout(function () {
      gasOrderGetPredictionStatus().then((data) => {
        let ok = true
        data.forEach((item) => {
          if (item['preStatus'] === 'P' && item['num'] > 0) {
            ok = false
          }
        })
        if (!ok) {
          dispatch('getOrderPredictionStatus')
        } else {
          dispatch('setPredictionLoading', false)
          dispatch('showNoticeMsg', {type: 'success', title: '系统提示', message: '预测完成！'})
          let parm = {
            sendTime: dateOperating.computeDay({days: 1, date: new Date(), format: 'yy-mm-dd'}),
            endTime: dateOperating.computeDay({days: 2, date: new Date(), format: 'yy-mm-dd'}),
            groupId: getters.currentGroupId,
            needVolume: 1,
            noPage: 1
          }
          dispatch('loadGasOrderList', parm)
        }
      }).catch(() => {
        dispatch('setPredictionLoading', false)
      })
    }, 5000)
  },
  setGasOrderSearchParm ({ commit, dispatch }, data) {
    commit('setGasOrderSearchParm', data)
    dispatch('dealGasOrderList')
  },
  setGasOrderSortParm ({ commit, dispatch }, data) {
    commit('setGasOrderSortParm', data)
    dispatch('dealGasOrderList')
  },
  setBaseGasOrderList ({ commit }, data) {
    commit('setBaseGasOrderList', data)
  },
  setGasOrderList ({ commit }, data) {
    commit('setGasOrderList', data)
  },
  setPredictionLoading ({ commit }, data) {
    commit('setPredictionLoading', data)
  }
}

const mutations = {
  gasOrderEditBaseOne (state, data) {
    state.baseGasOrderList.forEach((item, index) => {
      if (item.id === data.id) {
        for (let key in data) {
          item[key] = data[key]
        }
        state.baseGasOrderList[index] = dealGasOrder([item])[0]
      }
    })
  },
  gasOrderEditOne (state, data) {
    state.gasOrderList.forEach((item, index) => {
      if (item.id === data.id) {
        for (let key in data) {
          item[key] = data[key]
        }
        state.gasOrderList[index] = dealGasOrder([item])[0]
      }
    })
  },
  setGasOrderSearchParm (state, data) {
    state.gasOrderSearchParm = data
  },
  setGasOrderSortParm (state, data) {
    state.gasOrderSortParm = data
  },
  setBaseGasOrderList (state, data) {
    state.baseGasOrderList = data
  },
  setGasOrderList (state, data) {
    state.gasOrderList = data
  },
  setPredictionLoading (state, data) {
    state.predictionLoading = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/gas_order.js